import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token (fallback for environments that block cookies, e.g. iframes)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (path) => {
  if (!path) return "/gallery/placeholder.jpg";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  if (path.startsWith("/")) return path;
  return `${API}/files/${path}`;
};

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
